import { render, staticRenderFns } from "./TheNavbarVerticalCustom.vue?vue&type=template&id=287a4b33&"
import script from "./TheNavbarVerticalCustom.vue?vue&type=script&lang=js&"
export * from "./TheNavbarVerticalCustom.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarVerticalCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports